export default {
  sheetReuse: {"sizeNote":"치수 설명","sizeNotePlaceholder":"예: 립 완성 폭 5 cm, 신장 길이 40 cm, 접은 후 2 × 4 cm. 작업지시서 비고에 표시됩니다.","saveSizeNote":"치수 설명 저장","sizeNoteSaved":"치수 설명이 저장되었습니다","librarySizeNote":"소재 라이브러리 치수","methodPlaceholder":"측정 방법을 자유롭게 입력하거나 수정하세요","selectAll":"전체 선택","clearSelection":"선택 해제","replaceAll":"치수표 전체 교체","fillMissing":"빈 항목만 채우기","replaceWarning":"현재 {count}개 부위를 모두 교체하고 이번에 선택한 부위만 유지합니다.","tolerances":"허용오차 +{plus} / −{minus} · 편차 좌 {left} / 우 {right}","trimTitle":"이전 스타일 부자재 가져오기","trimHint":"필요한 부자재를 선택하여 현재 목록에 추가합니다. 이전 규격·색상·요척을 확인하세요. 견적은 복사하지 않으며 현재 첨부 또는 라이브러리 이미지를 사용합니다.","trimEmpty":"이전 작업지시서에 부자재 기록이 없습니다","trimSummary":"{count}행 선택, 가져온 후 총 {total}행. {capacity}행까지 추가할 수 있습니다.","trimApply":"선택한 {count}행 추가","trimSelectionInvalid":"유효한 부자재를 선택하세요. 전체 행 수는 200개를 넘을 수 없습니다.","trimUnsupported":"이전 부자재 자료에 지원되지 않는 필드 형식이 있습니다. 원본 확인 후 입력하세요.","dimension":{"width":"폭","height":"높이","length":"길이","tolerance":"허용오차","FINISHED":"완성 치수","UNFOLDED":"펼친 치수","FOLDED":"접은 치수","DIAMETER":"직경","OTHER":"치수"}},
  uiFeedback: { loading: '불러오는 중…', noMatches: '검색 조건에 맞는 기록이 없습니다', clearSearch: '검색 지우기', retry: '다시 불러오기', retrySave: '저장 다시 시도' },
  legacyAssigned: {"title":"SAP 배정 스타일 가져오기","scope":"본인에게 배정된 스타일만 생산 차수별로 의뢰서를 생성합니다.","years":"상품 연도","total":"스타일／차수 {count}건","refresh":"건수 새로고침","generate":"의뢰서 생성","stop":"이후 가져오기 중지","stopping":"현재 묶음을 처리 중입니다. 잠시 기다려 주세요…","running":"자료를 가져와 생성 중 · {count}건 처리…","finished":"가져오기 완료","summary":"신규 {created} · 기존 {existing} · 보완 {updated} · 제외 {skipped} · 실패 {failed}","style":"스타일 · 생산 차수","state":"처리 상태","result":"결과／보완할 정보","loadFailed":"가져오기에 실패했습니다. 다시 실행해도 이미 생성된 의뢰서는 중복 생성되지 않습니다.","designerOnly":"디자이너에게 배정된 스타일을 가져오는 기능입니다.","technical":"출처: SP0120 스타일／담당／계획 수량, SP0200 이전 담당 호환, SP0180 색상·사이즈. 현재 {system} legacy를 먼저 읽고 생성 시 자료가 부족하면 같은 생산 차수로 SP0110, SP0060을 조회합니다. 요청당 최대 한 스타일을 조회하며 실패하면 후속 조회를 중지합니다. 기존 본인 초안은 빈 상품 정보와 미초기화 수량표만 보완하며 DS 담당자, 입력 내용과 기존 번호를 유지합니다.","states":{"CREATED":"생성 완료","EXISTING":"기존 의뢰서","UPDATED":"자료 보완 완료","SKIPPED":"제외","FAILED":"실패"},"reasons":{"changed":"담당자, 연도 또는 브랜드가 변경되었습니다. 새로고침 후 다시 시도하세요.","ambiguous":"동일 스타일·차수의 출처가 중복됩니다. 관리자에게 확인하세요.","invalidIdentity":"스타일 또는 생산 차수 형식이 올바르지 않습니다.","cancelled":"SAP에서 취소 처리되었습니다.","failed":"이 항목 생성에 실패했습니다. 다시 시도한 후에도 실패하면 관리자에게 로그 확인을 요청하세요."},"notes":{"nameMissing":"품명 입력 필요","dimensionsMissing":"색상／사이즈 수신 대기","baseSizeMissing":"샘플 사이즈 선택 필요","quantityMissing":"일부 계획 수량 미수신","quantityInvalid":"일부 계획 수량 확인 필요"},"sapIncomplete":"SAP에서 품명, 색상 또는 사이즈를 완전히 반환하지 않아 빈 의뢰서를 생성하지 않았습니다. SAP 자료 확인 후 다시 시도하세요."},
  sapProgress: {"states":{"NOT_QUEUED":"PO 큐 등록 대기","PENDING":"PO 추출 대기","PO_CONSUMED":"PO 추출 완료","UNAVAILABLE":"확인 필요"},"hint":"4개 자료 인터페이스 성공 후 IF_ModelProgress에 상태 900을 등록합니다. PO가 해당 FLAG를 해제하고 XDATETIME을 기록하면 아래 버튼으로 확인 후 업무 상태를 갱신하세요. PO 추출은 SAP 최종 반영을 보장하지 않습니다.","extractedAt":"PO 추출 시각:","payload":"SP0250 JDBC 필드 보기","continue":"상태 전달 / PO 추출 확인","jdbcLog":"JDBC 전달 기록 (SAP 응답 아님)","environmentMismatch":"현재 SAP 환경과 SP0250 PO 수신 환경이 다릅니다. EADS_SP0250_SYS_GBN을 확인하세요.","invalidIdentity":"의뢰 번호, 스타일 또는 생산 차수가 SP0250 legacy 필드 범위를 초과합니다.","rowChanged":"SP0250 큐 기록이 없거나 변경되었습니다. PO와 DB를 확인하세요.","readFailed":"SP0250 큐 조회 실패. legacy 테이블 및 DB 권한을 확인하세요."},
  sapBatch: {"query":"SAP 생산 차수 조회 (SP0210)","selection":"SAP 생산 차수","initial":"SAP 차수 없음 · 최초 00 사용","refreshRequired":"SAP 조회 결과가 만료되었습니다. 스타일과 생산 차수를 다시 조회하세요.","batchUnavailable":"SAP 응답에 없는 생산 차수입니다. 다시 조회하여 선택하세요.","sheetExists":"해당 스타일 및 생산 차수의 의뢰서가 이미 있습니다. 기존 의뢰서를 열어 주세요."},
  usedParts: {
  "title": "사용 부위",
  "description": "현재 자재 사용 부위의 분류 코드와 명칭을 읽기 전용으로 확인합니다.",
  "refresh": "새로고침",
  "count": "현재 {total}개 · 활성 {active}개 · 표시 {shown}개",
  "sourceHint": "현재 명칭은 DS 사전, 분류 코드와 원명은 동일 코드의 레거시 자료입니다. 분류명은 제공되지 않아 추정하지 않습니다. 중국어 표시명에 영어 또는 한국어 원문이 남아 있을 수 있습니다.",
  "unavailable": "레거시 분류를 읽을 수 없어 DS 현재 목록만 표시합니다.",
  "search": "코드, 분류, 명칭 검색",
  "allSections": "모든 분류 코드",
  "empty": "일치하는 사용 부위가 없습니다",
  "section": "분류 코드 (레거시)",
  "code": "부위 코드",
  "nameZh": "중국어 표시명",
  "nameKo": "한국어 명칭",
  "nameEn": "영어 명칭",
  "status": "DS 상태",
  "active": "활성",
  "inactive": "비활성",
  "sourceName": "레거시 원명",
  "legacyOnly": "레거시에만 존재 (DS 목록에 없음)",
  "checkedAt": "조회 시각:"
},
  integrationReadiness: {
    recentFailure: "최근 프로시저 실행 실패 있음",
    onlyImplemented: "앱 구현 또는 수신 프로시저 준비만",
  "counts": "전체 {total} · 앱 구현 {implemented} · JDBC 프로시저 준비 {jdbc} · 표시 {shown}",
  "hint": "앱 구현과 DB 수신 프로시저는 별도 집계입니다. 프로시저 존재, 권한 또는 과거 성공만으로 현재 전체 연동을 확인할 수 없습니다.",
  "kind": {
    "application": "앱",
    "soap": "SOAP 수신",
    "jdbc": "JDBC → PO → ABAP Proxy (비동기)"
  },
  "deployment": {
    "present": "수신 프로시저 준비",
    "partial": "수신 프로시저 일부 누락",
    "missing": "수신 프로시저 없음",
    "unknown": "배포 상태 미확인"
  },
  "configured": "앱 수신 설정 준비",
  "notConfigured": "앱 수신 설정 미완료",
  "checkedAt": "현재 환경 조회 시각:",
  "jdbcHint": "레거시 저장이며 V2 동기화를 의미하지 않습니다. PI 경로와 소비 계약은 별도 확인이 필요합니다. sap_push 계정의 프로시저 실행 기록만 표시합니다. 공유 프로시저 기록은 특정 인터페이스의 성공을 증명하지 않으며 미기록 또는 롤백은 미호출을 의미하지 않습니다.",
  "soapHint": "코드와 환경 설정을 구분합니다. SAP 주소, 인증, 전문 및 응답 연동 확인이 필요합니다.",
  "routine": "수신 프로시저",
  "deployed": "존재",
  "permission": "sap_push 실행 가능",
  "success": "과거 성공 횟수",
  "failure": "과거 실패 횟수",
  "latest": "최근 프로시저 결과",
  "unknown": "미확인",
  "yes": "예",
  "no": "아니요",
  "noReceipt": "표시할 기록 없음"
},
  fabricUpdate: {
    retry: '재시도',
    title: '원단 자료 갱신 확인', sent: '공장에 발송한 작업지시서의 원단 자료는 갱신하지 않습니다.',
    hint: '연결 원단 자료가 변경되었습니다. 차이를 확인하세요. 기존 원단만 갱신하며 소요량, 단가, 사용 위치는 유지합니다.',
    saveFirst: '먼저 저장하지 않은 변경을 저장하거나 취소하세요.', row: '자재 {seq}행',
    accept: '갱신 확인', decline: '현재 자료 유지',
    confirm: '기존 행을 최신 원단 자료로 갱신할까요? 승인된 디자인은 기존 규칙에 따라 재확인합니다.',
    declineConfirm: '현재 자료를 유지할까요? 같은 버전은 다시 알리지 않으며 원단 변경 시 다시 알립니다.',
    fields: { materialCode:'시스템 원단 코드',brandMaterialCode:'브랜드 번호',materialNm:'원단명',materialAlias:'공급업체 품번',vendorNm:'공급업체',composition:'혼용률',finishing:'후가공' },
  },

  patternParts: {
  "title": "패턴 측정점",
  "description": "자주 사용하는 측정점과 3개 언어 명칭·측정법을 관리합니다. 기존 의뢰서 원문은 변경하지 않습니다.",
  "add": "측정점 추가",
  "configure": "측정점 {code} 설정",
  "code": "대표 코드",
  "name": "측정점 명칭",
  "family": "부위군",
  "aliases": "별칭 코드",
  "qualifier": "구분 조건 (참고)",
  "source": "측정법 출처",
  "evidence": "과거 사용 의뢰서 수",
  "categories": "적용 템플릿 코드",
  "unrestricted": "비워 두면 전체 적용. 여러 코드는 세미콜론으로 구분",
  "unit": "단위",
  "gradeSmall": "작은 사이즈 그레이딩",
  "gradeLarge": "큰 사이즈 그레이딩",
  "tolPlus": "플러스 허용치",
  "tolMinus": "마이너스 허용치",
  "status": "상태",
  "sortOrder": "정렬 순서",
  "enabled": "사용",
  "inactive": "사용 중지",
  "originalNames": "기존 원본 명칭",
  "legacyReview": "기존 원문. 중국어 번역은 패턴 담당자 검토 필요",
  "search": "코드·별칭·명칭·측정법 검색",
  "summary": "측정점 {points}개 · 부위군 {families}개 · 별칭 {aliases}개",
  "loadFailed": "측정점 설정을 불러오지 못했습니다. 새로고침해 주세요. 입력된 내용은 유지됩니다.",
  "duplicateCode": "대표 코드 또는 별칭이 이미 있습니다. 하나의 코드는 두 측정점에 연결할 수 없습니다.",
  "duplicatePoint": "같은 부위군에 동일한 명칭·구분 조건 또는 한국어 명칭·측정법이 있습니다.",
  "translationsRequired": "확정 측정점은 중국어·한국어·영어 명칭과 측정법을 모두 입력해야 합니다.",
  "notFound": "측정점이 없습니다.",
  "inUse": "템플릿 또는 의뢰서에서 사용 중입니다. 삭제 대신 사용 중지해 주세요.",
  "removeConfirm": "측정점 {code}를 삭제하시겠습니까? 사용 중인 측정점은 사용 중지만 가능합니다.",
  "families": {
    "NECK": "목부분",
    "SHLDR": "어깨·등",
    "SLEEVE": "소매",
    "CHEST": "가슴·등판",
    "WAIST": "허리",
    "HIP": "힙",
    "RISE": "시리·안기장",
    "LENGTH": "기장·밑단",
    "LEG": "다리둘레",
    "POCKET": "주머니",
    "HOOD": "후드",
    "TRIM": "부속"
  },
  "statuses": {
    "CONFIRMED": "확정",
    "DRAFT": "미확정"
  },
  "sources": {
    "STANDARD": "표준 정의",
    "LEGACY": "기존 원문"
  },
  "languages": {
    "zh": "중국어",
    "ko": "한국어",
    "en": "영어"
  }
},
  trimUnits: { piece: '개', strand: '개' },
  sapSync: {
  "completionRecord": "로컬 동기화 완료 기록 (전송 요청 없음)",
  "preparedEvent": "로컬 전송 대기 진행 정보(미전송)",
  "open": "확인 / 추가 전송",
  "fullMode": "의뢰서 전체 전송",
  "singleMode": "SP0070만 테스트",
  "testStyle": "이번 테스트 스타일",
  "sourceStyle": "원본 스타일: {style}",
  "intro": "D-BOM, 디자인, 원자재, 패턴 확정을 순서대로 전송한 후 SP0250 큐에 등록합니다. 값이 동일한 성공 항목은 건너뛰며 테스트 값은 의뢰서에 저장하지 않습니다.",
  "coreComplete": "4개 자료 인터페이스 성공. SP0250 PO 추출 상태를 확인하세요.",
  "mockCoreComplete": "인터페이스 4건의 모의 전송이 완료되었습니다. 실제 SAP 전송 및 의뢰서 상태 갱신은 없습니다.",
  "progressPending": "이전 미매핑 진행 이벤트 {count}건 보관 (자동 재전송 안 함)",
  "progressHint": "4개 자료 인터페이스 성공 후 IF_ModelProgress에 상태 900을 등록합니다. PO가 해당 FLAG를 해제하고 XDATETIME을 기록하면 아래 버튼으로 확인 후 업무 상태를 갱신하세요. PO 추출은 SAP 최종 반영을 보장하지 않습니다.",
  "reviewNotes": "전송 순서와 필드 확인 안내",
  "orderNote": "현재 순서는 SP0070 → SP0160 → SP0190 → SP0170입니다. 뒤의 3개 순서는 운영 확인 사항이며 SP0070 위치는 현재 구현안으로 CE2 검증이 필요합니다. 실패 시 중단하며 자동 재시도하지 않습니다.",
  "mappingNote": "후보값: 디자인 일자는 디자이너 업무 확인일, 원자재 일자는 구매 완료일, 패턴 일자는 기준 치수와 규격 모두 완료한 일자입니다. 담당자는 해당 의뢰서의 디자인/원단 구매/패턴 사번입니다. 패턴 플래그 1은 기존 인터페이스 예제이며 취소값은 추정하지 않습니다. 날짜 YYYYMMDD. 임시 수정 후 다시 분석하세요.",
  "confirmationFields": "확정 인터페이스 필드",
  "thisSend": "이번 전송값(임시)",
  "simulate": "미완료 항목 모의 전송",
  "sendRemaining": "미완료 항목 전송 / 계속",
  "awaitingChannel": "연결 대기 · 미전송",
  "invalidOperation": "의뢰서 핵심 전송 대상이 아닌 인터페이스입니다.",
  "previousRequired": "앞 단계 인터페이스부터 완료하세요. 순서 또는 값이 변경되어 다시 분석해야 합니다.",
  "retryInDialog": "해당 의뢰서의 SAP 전송 창에서 확인 후 미완료 항목을 계속하세요. SP0250 대기 기록은 SOAP 요청으로 재전송할 수 없습니다.",
  "states": {
    "READY": "전송 대기",
    "SUCCESS": "성공",
    "FAILED": "실패",
    "SENDING": "전송 중",
    "RECONCILE": "결과 확인 필요"
  },
  "fields": {
    "MainFixedDate": "디자인 확정일",
    "DSN_NO": "디자이너 사번",
    "MaterialFixedDate": "원자재 확정일",
    "PUR_NO": "원단 구매 사번",
    "PatternFixedDate": "패턴 확정일",
    "PATN_NO": "패턴 담당 사번",
    "ConfirmPatnYN": "패턴 확정 플래그"
  },
  "missing": {
    "MainFixedDate": "디자인 확정일이 없습니다. 테스트는 빈 노드를 보낼 수 있지만 정식 전송은 확인이 필요합니다.",
    "DSN_NO": "디자이너 사번을 확인하세요.",
    "MaterialFixedDate": "원자재 확정일이 없습니다. 테스트는 빈 노드를 보낼 수 있지만 정식 전송은 확인이 필요합니다.",
    "PUR_NO": "원단 구매 사번을 확인하세요.",
    "PatternFixedDate": "패턴 확정일이 없습니다. 테스트는 빈 노드를 보낼 수 있지만 정식 전송은 확인이 필요합니다.",
    "PATN_NO": "패턴 담당 사번을 확인하세요.",
    "ConfirmPatnYN": "패턴 확정 플래그가 없습니다. SAP 기준을 확인하세요. 취소값을 추정하지 않습니다."
  },
  "completed": "자료 인터페이스 성공 및 로컬 동기화 상태 기록 완료. SP0250 전달 상태는 아래에서, 최종 반영은 SAP에서 확인하세요.",
  "testOnly": "대체 스타일 또는 임시 확정 값으로 진행한 테스트는 원본 의뢰서 상태를 갱신하지 않습니다. 원본 스타일과 현재 업무 값으로 동기화해 주세요.",
  "finalize": "동기화 완료 처리 (SAP 재전송 없음)",
  "workClosed": "SAP 전송이 완료되었습니다. 담당 확인과 공장 전달은 별도로 진행합니다. 전송 내용이 바뀌면 다시 동기화해야 합니다.",
  "needsSync": "전송 내용 또는 확정 정보가 변경되었습니다. 확인 후 SAP에 다시 동기화해 주세요.",
  "sheetStates": {
    "NOT_SYNCED": "미동기화",
    "SYNCED": "SAP 동기화 완료",
    "NEEDS_SYNC": "SAP 재동기화 필요"
  }
},
  sapUsage: {
    "title": "관련 SAP 인터페이스",
    "readDirection": "SAP 조회 → 기획 초안",
    "writeDirection": "DS → SAP 전송",
    "readHint": "SP0210으로 생산 차수를 조회한 후 선택 차수의 SP0110 주자료와 SP0060 보충 자료를 가져옵니다. 동일 초안 요청은 재호출하지 않습니다.",
    "writeHint": "전체 전송은 핵심 인터페이스 4개를 순차 호출하며 SP0070 단독 테스트도 가능합니다. 업무 완료와 SAP 전송은 별개이며 사용자가 클릭해야 전송합니다.",
    "priority": "SP0070 → SP0160 → SP0190 → SP0170 → SP0250 (JDBC로 PO 전달)",
    "expandRead": "인터페이스 이름 및 필드 보기",
    "expandWrite": "회신 인터페이스 목록 보기 ({count}개)",
    "collapse": "인터페이스 목록 접기",
    "statusHint": "구현 상태는 현재 코드 기준입니다. 기존 목록 상태는 2026-08-26 자료 기준이며 현재 환경의 사용 가능 여부나 이번 전송 완료를 의미하지 않습니다.",
    "implementation": "구현 상태",
    "inWorkflow": "현재 흐름에 연결됨",
    "operationOnly": "호출 모듈 구현됨 · 업무 전송 미연결",
    "notImplemented": "미구현",
    "legacyStatus": "기존 목록 상태",
    "legacyEnabled": "사용으로 표시",
    "legacyDisabled": "미사용으로 표시",
    "transport": "호출 채널",
    "transports": {
      "soap": "SOAP → SAP",
      "jdbc": "기존 JDBC → ABAP Proxy · 연결 방식 확인 필요"
    },
    "requestRoot": "SOAP 요청 루트",
    "contract": "WSDL 파일",
    "soapFields": "요청 필드 / 노드",
    "referenceFields": "기존 목록 참조 필드",
    "coverageGap": "SP0070 성공이 의뢰서 전체 동기화를 의미하지는 않습니다. 기획 속성, 주문 수량, 개별 확정, 진행 이력, QC 및 패턴 파일의 전송 범위를 각각 확인해야 합니다. 계약이 확인되지 않은 자료는 로컬에 유지합니다.",
    "roles": {
      "batch": "생산 차수 조회",
      "progress": "JDBC 상태 전달",
      "primary": "① 기본 조회",
      "supplement": "② 보완 조회",
      "send": "이 창에서 전송",
      "confirmation": "전체 전송 연동",
      "evaluate": "연동 검토 필요",
      "hold": "사용 범위 확인 필요"
    },
    "interfaces": {
      "SP0210": {"title":"SAP 생산 차수","purpose":"스타일의 기존 생산 차수를 조회합니다. 최신 차수가 기본이며 다른 차수를 선택할 수 있습니다.","note":"WSDL은 StyleCD / StyleCDSeq를 반환하며 별도 D-BOM 번호는 없습니다. 생산 차수와 의뢰서 수정 버전은 별개입니다."},
      "SP0110": {
        "title": "스타일 기준 정보",
        "purpose": "연도, 시즌, 판매가, 입고 요청일, 담당자, 색상·사이즈 및 기획 수량을 조회합니다.",
        "note": "필수 조회입니다. 판매월, 성별 및 3단계 분류는 제공하지 않으므로 기획 담당자가 보완합니다."
      },
      "SP0060": {
        "title": "스타일 자료 및 기획 수량",
        "purpose": "품명, 색상·사이즈 범위와 기본 조회에서 제공하지 않은 기획 수량을 보완합니다.",
        "note": "SP0110 성공 후 조회하며 전체 스타일 목록 조회는 아닙니다. 기존 유효 값은 우선 유지하고 충돌 항목은 확인하도록 안내합니다."
      },
      "SP0070": {
        "title": "의뢰서 D-BOM",
        "purpose": "원단, 부자재, 패턴 치수, 배색, 디자인 메모 및 이미지·첨부 경로를 전송합니다.",
        "note": "헤더 12개 필드와 상세 6개 영역입니다. 확정일, 진행 이력, QC 전용 영역은 없습니다. 성공 응답 후에도 SAP CS03에서 실제 내용을 확인해야 합니다."
      },
      "SP0160": {
        "title": "디자인 확정",
        "purpose": "디자인 확정일과 담당자를 전송하여 SAP D-BOM 디자인 확정을 갱신합니다.",
        "note": "전체 전송에 연결되었습니다. 디자이너 업무 확인일과 해당 의뢰서 사번을 사용하며 테스트에서 임시 수정할 수 있습니다. Sel_Out 이름이지만 쓰기 인터페이스입니다."
      },
      "SP0190": {
        "title": "원자재 확정",
        "purpose": "원자재 확정일과 구매 담당자를 전송하여 SAP 원자재 확정을 갱신합니다.",
        "note": "전체 전송에 연결되었습니다. 구매 완료일과 해당 의뢰서 원단 구매 사번을 사용합니다. 디자인 확정 다음, 패턴 확정 이전입니다."
      },
      "SP0170": {
        "title": "패턴 확정",
        "purpose": "패턴 확정 표시, 패턴 담당 사번 및 확정일을 전송합니다.",
        "note": "전체 전송에 연결되었습니다. 기준 치수와 규격 모두 완료 시 확정일을 채우며 플래그 1은 기존 예제입니다. 취소값을 추정하지 않습니다. SP0070 순서 위치는 CE2 검증이 필요합니다."
      },
      "SP0250": {"title":"개발 진행 상태 및 담당자","purpose":"4개 자료 인터페이스 성공 후 legacy.IF_ModelProgress에 상태 900과 실제 작업자를 기록하여 PO에 전달합니다.","note":"제공된 PO JDBC SQL 계약을 사용합니다. FLAG 해제는 PO 추출 증거이며 SAP 업무 응답은 아직 제공되지 않았습니다."},
      "SP0240": {
        "title": "전체 단계 확정",
        "purpose": "디자인, 패턴, 원자재, 요척 확정일과 담당자를 일괄 전송하여 개발 진행표를 갱신합니다.",
        "note": "기존 목록은 미사용입니다. 운영팀은 CE3 미사용만 확인했으며 CE2 범위는 확인이 필요합니다. 개별 확정과 일부 중복되므로 임의 대체하거나 중복 전송하지 않습니다."
      },
      "SP0310": {
        "title": "QC 검사 결과",
        "purpose": "QC 유형, 차수, 검사 결과 및 반려 사유를 전송합니다.",
        "note": "로컬 QC 입력은 가능하지만 전송은 미연결입니다. 기존 목록은 비동기 JDBC 채널이며 제공 폴더에 WSDL이 없습니다. CE3는 미사용이고 CE2 범위와 비동기 응답을 확인해야 합니다."
      },
      "SP0320": {
        "title": "패턴 문서",
        "purpose": "패턴 파일 경로, 크기, 분류와 진행 단계를 별도로 등록합니다.",
        "note": "기존 목록은 미사용이며 WSDL은 있지만 현재 미연결입니다. 패턴 첨부 용도, 단계 코드, SAP 접근 가능 경로가 필요합니다. 반대 방향의 동일 번호 SP0320과 다른 인터페이스입니다."
      }
    }
  },
  sapDebug: {
  "close": "닫기",
  "open": "SAP 전송",
  "title": "SAP 전송 분석 및 테스트",
  "intro": "필드를 확인한 후 수동 전송합니다. 테스트 시 헤더의 StyleCD를 수정하면 모든 상세 행에 자동 반영됩니다. 이번 요청에만 적용되며 의뢰서는 변경하지 않습니다. 생산 차수·의뢰번호·대상 시스템은 고정됩니다.",
  "styleTarget": "의뢰서 원래 스타일: {source} → 이번 SAP 수신 스타일: {target}",
  "invalidStyleCd": "이번 테스트 스타일 번호를 입력하세요 (1~30자).",
  "trimWarningTitle": "업무 누락 안내(테스트 창에서 전송 가능)",
  "trimWarningHint": "CE2 테스트에서는 미완료 자료, 임시 번호, 미준비 부자재로 전송할 수 있으며 SAP 실제 응답을 확인합니다. 정식 전송의 업무 검증은 유지됩니다.",
  "fieldsTitle": "필드 설정",
  "section": "데이터 구간",
  "row": "상세 행",
  "rowNumber": "{number}행",
  "rowCount": "{count}행 · 빈 값 {empty}개",
  "field": "필드 / SOAP 이름",
  "original": "시스템 값",
  "sendValue": "이번 전송 값",
  "empty": "빈 문자열",
  "locked": "현재 의뢰서 또는 서버 설정에서 결정",
  "noRows": "상세가 없으므로 생략됩니다. 테스트 행을 추가할 수 있습니다.",
  "schemaHint": "모든 노드는 xsd:string입니다. 헤더 12개 및 상세 행 노드는 존재해야 하지만 빈 문자열도 허용됩니다. 상세 구간은 0개 이상이며 빈 구간은 생략합니다. 빈 값 개수는 확인용입니다.",
  "notes": "인터페이스 규칙 및 확인 사항",
  "contractNotes": "WSDL은 노드 이름·순서·타입을 정의하며 SAP의 빈 값 허용을 보장하지 않습니다. TechPack_NO, 첨부 경로, 이미지 D/G, FileID, 단가 통화, 부자재 소요량/중량 기준과 기본 플래그 0은 SAP 확인이 필요합니다. 성공 후 CS03에서 실제 내용을 확인하세요.",
  "relativeImage": "일부 첨부가 상대 경로여서 SAP에서 읽지 못할 수 있습니다. SAP가 접근 가능한 경로를 입력하세요.",
  "request": "요청 전문",
  "logs": "진행 및 전송 로그",
  "response": "SAP 응답 및 통신 정보",
  "sentRequest": "실제 전송 매개변수",
  "recentLogs": "이 의뢰서의 최근 SP0070 기록 20건",
  "reload": "시스템 값 다시 불러오기",
  "analyze": "매개변수 재분석",
  "reanalyze": "매개변수가 변경되었습니다. 재분석 후 전송하세요",
  "send": "{system}에 전송 ({style})",
  "simulate": "모의 전송 실행",
  "analyzed": "필드 분석 및 사전 검사가 완료되었습니다. SAP는 호출하지 않았습니다.",
  "started": "전송 시작: {adapter} / {system}, SAP 수신 스타일: {style}.",
  "waiting": "응답 대기 중이며 보통 약 35초 걸립니다. 중복 전송하지 마세요.",
  "success": "SAP 성공 응답 XSTAT=S를 받았습니다.",
  "mockSuccess": "모의 실행 성공. 실제 SAP에는 전송하지 않았습니다.",
  "mockNotice": "현재 mock 어댑터이므로 실제 SAP와 통신하지 않습니다.",
  "failed": "전송 실패. 아래 응답을 확인하세요.",
  "reconcile": "SAP 대사가 필요하며 중복 전송이 차단되었습니다.",
  "reconcileRetry": "이번 처리 결과는 아직 확인되지 않았으며 로그를 보존했습니다. 테스트 모드에서는 다시 수동 전송할 수 있습니다.",
  "testRetryEnabled": "CE2 테스트 모드: 반복 전송 허용",
  "testRetryHint": "시간 초과, 빈 응답 또는 실패 기록은 다음 테스트를 차단하지 않습니다. 요청 종료 후 바로 다시 전송할 수 있으며 매개변수 변경 시 재분석이 필요합니다. 클릭할 때마다 SAP에 새 요청을 보내며 이전 결과와 인증 보호는 유지됩니다.",
  "blocked": "전송할 수 없습니다. 다음 사항을 처리하세요",
  "stale": "의뢰서·부자재 매핑·설정이 변경되었습니다. 시스템 값을 다시 불러와 확인하세요.",
  "identityChanged": "생산 차수·의뢰번호·대상 시스템은 테스트 매개변수에서 변경할 수 없습니다.",
  "adapterUnavailable": "현재 SAP 어댑터는 구현되지 않았습니다.",
  "notConfigured": "실제 SAP 통신이 비활성 상태이거나 설정이 부족합니다.",
  "circuitOpen": "인증 차단기가 열려 전송하지 않습니다. 계정 확인 후 관리자에게 요청하세요.",
  "timeout": "인터페이스 제한 {seconds}초",
  "authRemaining": "인증 실패 허용 잔여: {count}",
  "sections": {
    "header": "헤더 (12 필드)",
    "MainDtl_Material": "원자재 상세",
    "DesignMemo": "디자인 메모",
    "MainDtl_Pattern": "패턴 치수",
    "MainDtl_ColorWay": "컬러웨이 상세",
    "DtlImg": "이미지 자료",
    "ModelSubMaterial": "부자재 상세"
  },
  "fields": {
    "StyleCD": "스타일 번호",
    "StyleCDSeq": "생산 차수",
    "AttachmentFilePath": "첨부 경로",
    "ModelCD": "의뢰 번호",
    "ItemCD": "품목 코드",
    "CAD_NO": "CAD 담당 번호",
    "TechPack_NO": "테크팩 담당 번호",
    "DesignerSAPYN": "디자인 SAP 플래그",
    "TechPackSAPYN": "테크팩 SAP 플래그",
    "FileSize": "파일 크기 (바이트)",
    "ORGFILE": "원본 파일명",
    "SysGBN": "대상 시스템",
    "MaterialCD": "원자재 코드",
    "MaterialItemCD": "원자재 품목 / 기존 별칭",
    "Yardage": "원자재 소요량",
    "Width": "원단 폭",
    "ColorMatchPartCD": "배색 부위",
    "MaterialAlias": "원자재 명칭 / 별칭",
    "MaterialMemo": "원자재 메모",
    "UnitPrice": "단가 (통화 노드 없음)",
    "UsedPartCD": "사용 부위 코드",
    "TagColorCD": "적용 색상 코드",
    "DSGNK": "공급처 / DSGNK",
    "DesignMemo": "디자인 메모 내용",
    "Seq": "부위 순번",
    "SizeCD": "사이즈 코드",
    "PatternPartCD": "패턴 부위 코드",
    "PatternPartNm": "패턴 부위명",
    "StdSize": "샘플 사이즈",
    "Size": "치수 값",
    "TorlnceL": "좌측 그레이딩",
    "TorlnceR": "우측 그레이딩",
    "Measurement": "측정 방법",
    "PlusTol": "플러스 허용치",
    "MinusTol": "마이너스 허용치",
    "ModelColorWaySeq": "컬러웨이 순번",
    "CoreColorNM": "배색명",
    "StdColorCD": "배색 표준 코드",
    "IKIND": "이미지 유형",
    "FileID": "SAP 파일 번호",
    "SubMaterialCD": "부자재 SAP 자재 번호",
    "SubMaterialUsedPart": "부자재 사용 부위",
    "SubMaterialMemo": "부자재 명칭 / 내용",
    "Gauge": "규격",
    "GaugeUnit": "규격 단위",
    "SubMaterialColorNm": "부자재 색상명",
    "RealYardage": "부자재 소요량",
    "Unit": "소요량 단위",
    "POSNR": "BOM 항목 번호",
    "Weight": "실제 소요량 / 중량",
    "WeightUnit": "실제 소요량 / 중량 단위",
    "ZUNITID": "SAP 단위 식별자"
  }
},
  packRefinement: { completePattern: '패턴·치수 완료', patternDone: '패턴·치수 완료됨' },
  app: {
    name: 'Design Sheet',
    shortName: 'Design Sheet',
    wordmarkDesign: 'design',
    wordmarkSheet: 'sheet',
    company: 'E·LAND China',
  },

  common: {
    close: '닫기',

    confirm: '확인',
    cancel: '취소',
    save: '저장',
    saved: '저장되었습니다',
    deleted: '삭제됨',
    saveDraft: '임시저장',
    submit: '제출',
    delete: '삭제',
    actions: '작업',
    edit: '수정',
    detail: '상세',
    expandDetails: '상세 펼치기',
    collapseDetails: '상세 접기',
    search: '조회',
    select: '선택',
    reset: '초기화',
    export: '내보내기',
    back: '뒤로',
    loading: '불러오는 중…',
    refresh: '새로고침',
    noData: '데이터 없음',
    total: '총 {n} 건',
    operation: '작업',
    createdAt: '생성일시',
    updatedAt: '수정일시',
    createdBy: '생성자',
    yes: '예',
    no: '아니오',
    language: '언어',
  },

  auth: {
    homeHeadlineFirst: '디자인 시안에서,',
    homeHeadlineLast: '테크팩까지.',
    homeDescription: '스타일 자료를 정리하고 원부자재·패턴·치수를 함께 완성하여 생산에 전달합니다.',
    homeHeroAlt: '마네킹, 원단과 디자인 스케치가 놓인 의상 디자인 스튜디오',
    homeFeaturesLabel: '주요 업무',
    homeDesignTitle: '디자인 자료',
    homeDesignDescription: '시안을 가져오고 스타일 정보를 정리합니다.',
    homeCollaborateTitle: '협업 입력',
    homeCollaborateDescription: '원부자재와 패턴·치수를 함께 완성합니다.',
    homeTechPackTitle: '테크팩',
    homeTechPackDescription: '자료를 확인하고 미리보기·내보내기를 진행합니다.',
    loginHelp: '로그인 도움말',
    homeNavigation: '홈 내비게이션',
    homeCopyright: '© 2026 E·LAND GROUP. All Rights Reserved.',
    loginHelpScanTitle: '기업 위챗 로그인',
    loginHelpScanDescription: '기업 위챗으로 이 페이지의 QR 코드를 스캔해 로그인해 주세요.',
    loginHelpAccessTitle: '로그인 지원',
    loginHelpAccessDescription: '로그인이 되지 않거나 사용 권한 신청이 필요한 경우, 기업 위챗으로 孟宪秋에게 문의해 주세요.',
    homeAboutTitle: 'Design Sheet 소개',
    homeAboutGoalTitle: '프로젝트 목표',
    homeAboutDescription: 'Design Sheet는 스타일 자료, 원부자재, 패턴·사이즈와 테크팩을 한곳에 모아 디자인부터 생산 인계까지 담당자 간 협업을 지원합니다. 중복 입력을 줄이고 수정·확인 이력을 남깁니다.',
    homeAboutRoles: '상품기획, 디자이너, 원부자재 구매, 패턴사, 생산관리 및 디자인 실장의 협업을 지원합니다.',
    homeAboutProgressTitle: '현재 진행 상황',
    homeAboutProgressDescription: '현재 ND·EE 브랜드의 테스트 단계이며 자료 가져오기, 협업 입력, 디자인 승인, Tech Pack 미리보기와 내보내기를 지원합니다. 주문 시스템·SAP 데이터 연동은 검증 중이며 데이터 연결과 사용 흐름을 계속 개선할 예정입니다.',
    homeAboutFeedbackTitle: '의견 전달',
    homeAboutFeedbackDescription: '사용 중 문제나 개선 의견이 있으면 기업 위챗으로 孟宪秋에게 문의해 주세요. 관련 품번, 작업 내용이나 화면 캡처를 함께 보내 주세요.',
    esiLogin: '기업 위챗 QR 로그인',
    continueWecomLogin: '로그인 계속하기',
    openWecomLogin: '기업 위챗 로그인 페이지 열기',
    qrLoading: 'QR 코드를 불러오는 중…',
    qrUnavailable: 'QR 코드를 불러올 수 없습니다',
    esiNoAccess: '이 계정은 Design Sheet 사용 권한이 없습니다. 관리자에게 문의하세요',
    testAccountLogin: '테스트 계정 로그인',
    loginTitle: '로그인',
    loginSubtitle: '계정과 비밀번호를 입력하세요',
    username: '계정 / 사번',
    password: '비밀번호',
    usernamePlaceholder: '계정 또는 사번을 입력하세요',
    passwordPlaceholder: '비밀번호를 입력하세요',
    login: '로그인',
    logout: '로그아웃',
    logoutConfirm: '로그아웃 하시겠습니까?',
    loginSuccess: '로그인되었습니다',
    sessionKept:
      '서비스가 일시적으로 이용 불가합니다. 로그인 상태는 유지되어 있으니 복구 후 「다시 시도」를 누르세요. 비밀번호를 다시 입력할 필요는 없습니다.',
    retryRestore: '다시 시도',
    changePassword: '비밀번호 변경',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '새 비밀번호 확인',
    profile: '내 정보',
    department: '부서',
    roles: '역할',
  },

  styleRegistry: {
    search: '스타일 번호 또는 품명 검색', currentOwners: '현재 담당자', currentVersion: '현재 유효 버전', sheetVersions: '{count}개 버전', receiptDiagnostics: '수신 진단',
    overview: '스타일 번호 전체', gallery: '디자인 자료', allYears: '전체 연도', allBrands: '전체 브랜드', year: '상품 연도', brand: '브랜드',
    assignment: '디자이너 배정', assignmentALL: '전체 배정 상태', assignmentUNASSIGNED: '디자이너 배정 필요', assignmentASSIGNED: '디자이너 배정 완료',
    sheetState: '의뢰서', sheetsALL: '전체 생성 상태', sheetsWITH: '의뢰서 있음', sheetsWITHOUT: '의뢰서 없음',
    total: '스타일／생산 차수 {count}건', batchHint: '생산 차수별로 표시합니다. 수신한 SAP 스타일과 DS 기존 스타일을 포함합니다.',
    styleCd: '스타일 번호', batch: '생산 차수', name: '품명', yearSeason: '연도／시즌', source: '출처',
    sourceSAP_RECEIVED: 'SAP 수신 완료', sourceDS_ONLY: 'DS 의뢰서', sourceCACHE: '로컬 스타일 캐시',
    needsAssignment: '배정／계정 확인 필요', local: 'DS 내부 배정', notCreated: '의뢰서 미생성', manage: '조회／배정', view: '상세 조회', detail: '스타일 정보 및 담당자',
    readonlyHint: '기본 자료는 읽기 전용이며 SAP 원본은 SAP에서 관리합니다. 품명은 기존 의뢰서 또는 로컬 스타일 캐시를 사용합니다.',
    linkedSheets: '연결된 의뢰서', existingHint: '저장 시 해당 스타일과 생산 차수의 현재 유효 의뢰서 및 담당 업무를 함께 변경합니다. 과거 버전은 유지하며 기존 승인·인계 규칙을 적용합니다.', openSheet: '의뢰서 조회',
    sapOwners: 'SAP 원 담당자 및 DS 배정', sapValue: 'SAP 사번: {value}', inherit: 'SAP 배정 사용', unassigned: '미배정',
    localHint: 'DS 내부 담당자만 저장하며 SAP에 전송하지 않습니다. 수신한 스타일은 자동 수신 규칙에 따라 의뢰서를 생성합니다. 생산 차수가 없는 캐시는 생성하지 않습니다.',
    save: 'DS 담당자 저장', saved: 'DS 담당자를 저장했습니다', notFound: '스타일이 없거나 조회 권한이 없습니다',
    notAssignable: '스타일 번호·브랜드·생산 차수에 오류가 있거나 SAP 원본이 중복되었습니다. 원본 자료를 먼저 확인하세요.',
    useSheetAssignment: '의뢰서가 이미 있습니다. 새로고침 후 연결된 의뢰서에서 담당자를 변경하세요.', personChanged: '배정 계정의 역할 또는 브랜드 권한이 변경되었습니다. 스타일 번호 전체 화면에서 다시 배정하세요.',
  },
  styleLibrary: {
    searchCode: '품번 검색 (일부 입력 가능)',
    search: '검색',
    clearSearch: '검색 지우기',
    searchResults: '품번 “{keyword}” 검색 결과: {count}개',
    noSearchResults: '일치하는 품번이 없습니다',
    noImage: '스타일 이미지 없음',
    imageLoading: '이미지 로딩 중',
    imageFailed: '이미지를 불러올 수 없습니다',
    title: '스타일 라이브러리',
    eyebrow: 'STYLE LIBRARY',
    desc: '전체 스타일을 시즌·품목·상태로 탐색합니다. 폴더를 열면 스타일이 표시됩니다',
    mode: '보기 방식',
    bySeason: '시즌별',
    byCategory: '품목별',
    byStage: '상태별',
    styles: '{count} 스타일',
    loading: '불러오는 중…',
    empty: '스타일이 없습니다',
    emptyHint: '의뢰서가 만들어지면 시즌·품목·상태별로 자동 분류됩니다',
    more: '{count} 스타일 더 있습니다',
    loadMore: '더 불러오기',
    loadedOf: '{loaded} / {total} 스타일 표시',
    ungrouped: '미분류',
    phaseDesign: '디자인시트',
    phaseSample: '샘플',
    phaseProduction: '양산',
  },
  fabricStockInit: {
    title: '원단 재고',
    desc: '이미 창고에 있는 원단 재고를 한 번에 등록합니다. 기초 재고는 별도 유형으로 기록되어 구매 입고나 재고 조정으로 잡히지 않으며, 기존 잔량을 덮어쓰지 않습니다.',
    downloadTemplate: '기초 템플릿 다운로드',
    importInit: '기초 재고 업로드',
    tabIntro: '사용 방법',
    tabBatches: '업로드 기록',
    howTitle: '기초 재고 등록 4단계',
    how1: '「기초 템플릿 다운로드」를 누르면 현재 브랜드의 정식 원단과 색상(생지 GRE 포함)이 한 줄에 하나씩 채워집니다.',
    how2: '템플릿에 「보관 장소 코드」「기초 재고 수량」「재고 단위」를 입력합니다. 같은 색상을 여러 장소에 두면 행을 복사해 장소만 바꿉니다.',
    how3: '「기초 재고 업로드」로 검증·미리보기 하면 오류가 엑셀 행 번호와 항목으로 표시됩니다.',
    how4: '확인 후 입고 처리하면 전체가 한 번에 반영되며, 이후 「업로드 기록」에서 배치와 상세를 볼 수 있습니다.',
    rulesHint: '수량을 비우면 처리하지 않고, 0은 「실사 완료·기초 0」으로 기록됩니다. 단위는 M / YD / KG만 가능하며 자동 환산하지 않습니다.',
    batchNo: '배치 번호',
    stockDate: '실사 기준일',
    status: '상태',
    rows: '행 집계',
    quantity: '수량 합계',
    file: '원본 파일',
    people: '등록자 / 시간',
    detail: '상세',
    revoke: '배치 취소',
    noBatches: '기초 재고 기록이 없습니다',
    rowCounts: '총 {total}행(입고 가능 {ok} · 기초 0 {zero} · 건너뜀 {skipped})',
    statuses: { COMMITTED: '입고 완료', REVOKED: '취소됨' },
    stepFile: '파일 선택',
    stepPreview: '미리보기 확인',
    stepDone: '완료',
    fileRequired: '엑셀 파일을 먼저 선택하세요',
    dateRequired: '실사 기준일을 선택하세요',
    stockDateHint: '배치 전체에 하나의 날짜를 적용합니다. 엑셀에 행마다 적지 않으며, 등록 시각과 별도로 저장됩니다.',
    memo: '배치 비고',
    totalRows: '파일 전체 행',
    committable: '입고 가능',
    zeroRows: '기초 0',
    skipped: '수량 없음',
    errorRows: '오류 행',
    qtyByUnit: '단위별 합계: ',
    blockedByErrors: '오류 행이 있어 전체를 입고할 수 없습니다. 수정 후 다시 업로드해 주세요(부분 성공으로 인한 중복 집계를 막습니다).',
    rowNo: '행',
    fabricCode: '원단 코드',
    colorCode: '색상',
    location: '보관 장소',
    unit: '단위',
    result: '검증 결과',
    lineStatuses: { COMMITTED: '입고 가능', ZERO: '기초 0', SKIPPED: '건너뜀', ERROR: '오류' },
    confirmHint: '확인하면 전체가 한 번에 입고됩니다. 같은 파일을 다시 제출해도 기초 재고가 두 번 잡히지 않습니다.',
    upload: '업로드 검증',
    back: '수정하기',
    confirm: '입고 확정',
    doneTitle: '기초 재고가 입고되었습니다',
    committedHint: '배치 {batch} 입고 완료. 「업로드 기록」에서 상세를 확인하세요.',
    reusedHint: '이 파일은 이미 입고된 적이 있습니다(배치 {batch}). 이번에는 중복 집계하지 않았습니다.',
    revokeTitle: '기초 재고 배치 취소',
    revokeReasonHint: '취소 사유를 입력하세요',
    revokeReasonRequired: '취소 시 사유는 필수입니다',
    revokeReason: '취소 사유',
    revoked: '취소되었고 역분개가 생성되었습니다',
    downloadOriginal: '원본 파일 다운로드',
    noOriginal: '이 배치에는 원본 파일이 보관되지 않았습니다(저장 시 오브젝트 스토리지 사용 불가).',
    tabStock: '재고 잔량',
    stockKeyword: '원단 코드 또는 이름 검색',
    stockOnlyMoved: '입출고 있는 원단만',
    stockEmpty: '조건에 맞는 원단이 없습니다',
    colFabric: '원단',
    colCategory: '품목',
    colNet: '현재 재고',
    colIn: '누적 입고',
    colOut: '누적 출고',
    colLastTxn: '최종 변동',
    colColors: '색상 수',
    templateTitle: '기초 템플릿 다운로드',
    templateScope: '내보내기 범위',
    templateSearch: '원단 코드 또는 이름 필터',
    templateSelected: '{n}개 원단 선택됨',
    templateAllHint: '선택하지 않으면 현재 브랜드의 모든 정식 원단을 내보냅니다',
    estimatedRows: '예상 {n}행(1행 = 원단 + 색상)',
    templateEmpty: '조건에 맞는 원단이 없습니다',
    download: '다운로드',
    downloadResult: '검증 결과 다운로드',
    locationManage: '보관 장소 관리',
    locationHint: '보관 장소는 공장 마스터를 사용합니다. 사용 중지한 장소는 새 기초 등록에 쓸 수 없습니다.',
    locationCode: '장소 코드',
    locationName: '장소 이름',
    locationNameEn: '영문명',
    locationAdd: '장소 추가',
    locationEmpty: '등록된 보관 장소가 없습니다',
    locationActive: '사용',
    locationInactive: '중지',
    templateDownloaded: '템플릿을 다운로드했습니다',
  },
  fabricCodeRule: {
    noEnabledBrand: '브랜드 관리에서 브랜드를 하나 이상 활성화해 주세요.',
    title: '원단 채번 규칙',
    eyebrow: 'SYSTEM',
    desc: '원단 카테고리의 문자 코드, 두 키팩터의 의미, 카테고리별 키팩터 값를 관리합니다. 원단 라이브러리의 선택 목록은 이 페이지를 기준으로 합니다.',
    composeHint: '원단 정식 코드 = 카테고리 문자(1) + 키팩터 1(2) + 키팩터 2(3, 숫자 0 채움) + 4자리 순번. 카테고리와 키팩터 1은 이 페이지에서, 순번은 시스템이 발번합니다.',
    partCategory: '카테고리 문자',
    partKf1: '키팩터 1',
    partKf2: '키팩터 2',
    partSeq: '순번',
    category: '원단 카테고리',
    noMeaning: '의미 미설정',
    inactive: '중지됨',
    kf1List: '키팩터 1 선택값',
    addKf1: '값 추가',
    editKf1: '값 수정',
    editCategory: '카테고리 수정',
    code: '코드',
    nameZh: '중문명',
    nameEn: '영문명',
    used: '사용',
    status: '상태',
    enabled: '사용',
    disabled: '중지',
    disable: '중지',
    enable: '사용',
    categoryLabel: '표시명',
    kf1Meaning: '키팩터 1 의미',
    kf1MeaningHint: '예: 대표혼용 / 조직',
    kf2Meaning: '키팩터 2 의미',
    kf2MeaningHint: '예: 데니어·변수·중량 / 중량 / 온스',
    sort: '정렬',
    charImmutable: '카테고리 문자는 코드 첫 자리이므로 등록 후 변경할 수 없습니다.',
    codeImmutable: '코드는 2-3번째 자리이므로 등록 후 변경할 수 없습니다. 더 이상 쓰지 않으면 중지하세요.',
    configure: '값 설정 {code}',
    configureCategory: '카테고리 설정 {code}',
    nameKo: '한국어명',
    fromDoc: '문서',
    fillFromDoc: '문서 값으로 3개 언어 채우기',
    docNotFound: '문서 대조표에 없는 코드입니다',
    docNameConflict: '카테고리 기준 또는 기존 이름이 문서와 다릅니다. 같은 코드만으로 3개 언어를 채울 수 없습니다. 먼저 의미를 확인해 주세요.',
    docConflictingCodes: '같은 코드의 의미·이름 확인 필요: {codes}',
    nameLimit: '영문명을 입력해 주세요. 각 언어의 이름은 100자를 넘을 수 없습니다.',
    showInactive: '사용 중지 항목 표시',
    docTitle: '《소재코드 구성 및 KeyFactor 대조표》와 대조',
    docHint: '왼쪽은 현재 DB 값이며 취소선은 문서와 다른 기준입니다. 차이만 표시하며 마스터 데이터를 자동으로 바꾸지 않습니다.',
    docVerdict: '카테고리 의미 대조',
    docAligned: '카테고리 의미 일치',
    docMismatch: '문서와 불일치',
    docMissingCategory: 'DB 미등록',
    docCoverage: '문서 {doc}건 · DB {db}건',
    docMissingInDb: '문서에 있으나 미등록: {codes}',
    docNotListed: 'DB에만 있음(문서 미기재): {codes}',
    dropdownHint: '여기 값이 원단 라이브러리 편집 화면의 선택 목록이 됩니다. 중지해도 기존 기록은 유지됩니다.',
  },
  nav: {
    integrations: "인터페이스 및 동기화 진단",
    dashboard: '워크벤치',
    workbench: '내 할 일',
    sheet: '의뢰서',
    sheetList: '의뢰서 목록',
    legacySheets: '과거 의뢰서',
    sheetDetail: '의뢰서 상세',
    sheetCreate: '의뢰서 생성',
    sheetApproval: '의뢰서 승인',
    spec: '사양 입력',
    fabricWidth: '원단 폭',
    trimAttr: '부자재 정보',
    baseSize: '기준치수',
    materialUsage: '원자재 소요량',
    trimUsage: '부자재 소요량',
    sizeTolerance: '치수 편차',
    sap: 'SAP 전송',
    sapTransfer: '데이터 전송',
    sapLog: '전송 이력',
    permissions: '역할 권한 안내',
    admin: '시스템 관리',
    userManage: '사용자 및 접근 권한',
    colorDict: '컬러',
    sizeDict: '사이즈',
    supplierMaster: '업체 관리',
    costConfig: '원가 및 환율',
    subMaterials: '부자재 관리',
    business: '업무',
    system: '시스템',
    masterData: '기준정보',
    group: {
      configuration: '업무 설정',
      workbench: '워크벤치',
      library: '과거 자료',
      materials: '자재 관리',
      orders: '주문 및 협업',
      system: '시스템 관리',
    },
    menu: {
      adminOverview: '관리 개요',
      suppliers: '공급업체 정보',
      brandApproval: '브랜드 및 승인',
      reorderProduction: '리오더 생산 확인',
      fabricLibrary: '원단 관리',
      trimLibrary: '부자재 관리',
      orderManagement: '주문 수신',
      factoryCollab: '공장 협업',
      masterDict: '기준 사전',
      costParams: '원가 및 환율',
    },
    masterDicts: '기준 사전',
    roleManage: '역할·권한',
    about: '도움말 및 정보',
    auditLog: '작업 감사',
    sapTransfers: 'SAP 전송 이력',
  },

  role: {
    ADMIN: '시스템 관리자',
    APPROVER: '디자인 실장',
    DESIGNER: '디자이너',
    PRODUCTION: '생산관리',
    FABRIC: '원부자재 구매',
    PATTERN: '패턴사',
    PLANNER: '상품기획',
    VIEWER: '조회 전용',
  },

  perm: {
    mgrTitle: '사용자 권한 관리',
    mgrHint: '기본은 역할을 따르고, 개별 사용자에게 권한을 직접 지정하면 「커스텀」으로 표시됩니다. 저장 후 해당 사용자는 재로그인해야 적용됩니다.',
    searchUser: '사용자 검색',
    pickUser: '← 사용자를 선택하세요',
    custom: '커스텀',
    roleDefault: '현재 역할 기본 권한',
    resetToRole: '역할 기본으로 복원',
    revokeHint: '저장 시 해당 사용자의 로그인 상태가 해제됩니다(권한이 토큰에 있음). 사용 중인 창은 최대 2시간 후 자동 만료됩니다.',
    saved: '권한 저장됨',
    desc: '이 페이지는 시스템의 권한 정의에서 실시간으로 생성됩니다. 손으로 쓴 문서가 아니므로 규칙이 바뀌면 즉시 반영됩니다.',
    mine: '내 권한',
    myScopes: '현재 편집 가능한 모듈',
    noneEditable: '없음(이 역할은 의뢰서 입력에 참여하지 않습니다)',
    adminNote: '시스템 관리자는 모든 모듈이 허용되며 아래 표의 제한을 받지 않습니다.',

    matrixTitle: '누가 무엇을 편집할 수 있는가',
    matrixHint:
      '의뢰서는 아래의 「편집 영역」으로 나뉘며 각 영역마다 담당 역할이 정해져 있습니다. 역할은 병행으로 작업하며 서로를 막지 않습니다. 오른쪽에서 문서 상태를 바꾸면 상태별로 누가 잠기는지 볼 수 있습니다.',
    previewStatus: '이 상태로 보기',
    scope: '편집 영역',
    approvalBound: '디자인 승인의 영향을 받음',
    legendYes: '편집 가능',
    legendLocked: '담당이지만 현재 상태에서는 잠김',
    legendNo: '편집 불가(조회만)',

    stagesTitle: '단계 완료 표시는 누가 하는가',
    stagesHint:
      '같은 절의 여러 표시가 서로 다른 역할에 속할 수 있습니다 —— 원부자재 절의 세 표시는 각각 다른 사람이 누릅니다.',
    section: '절',
    stage: '완료 표시',
    owner: '담당 역할',
    adminOnly: '시스템 관리자만',

    approvalTitle: '디자인 승인 흐름',
    flowSubmit: '디자이너 요청',
    flowApprove: '디자인 실장 승인',
    flowReject: '디자인 실장 반려',
    flowResubmit: '디자이너 수정 후 재요청',
    ruleParallel:
      '디자이너가 담당하는 내용만 승인합니다. 다른 역할은 승인 상태와 무관하게 언제든 입력할 수 있습니다.',
    rulePendingLock: '승인 대기 중에는 디자인 내용이 잠깁니다 —— 심사 중인 내용은 바뀌면 안 됩니다.',
    ruleEditAfterApprove:
      '승인 후에도 수정할 수 있지만, 수정하면 승인이 무효가 되어 자동으로 임시저장으로 돌아가며 다시 요청해야 합니다(상태 이력에 기록됩니다).',
    ruleRejectMemo:
      '반려 시 사유는 필수이며 디자이너가 이를 보고 수정합니다. 반복 반려·재요청이 가능하고 매 회차가 기록됩니다.',
    ruleCancelled: '문서가 폐기되면 모든 모듈을 편집할 수 없습니다.',

    rolesTitle: '역할별 권한 포인트',
    rolesHint:
      '권한 포인트는 해당 API에 들어갈 수 있는지를, 위의 편집 영역은 들어간 뒤 어디를 고칠 수 있는지를 결정합니다. 둘 다 충족해야 합니다.',
    permissionCount: '개 권한 포인트',
    myRoleNote: '내 역할은 「{role}」이며 권한 포인트는 {n}개입니다.',

    source:
      '데이터 출처: 편집 영역은 공유 패키지 constants/edit-scopes.ts, 권한 포인트는 데이터베이스의 역할 설정입니다.',
  },

  editScope: {
    SOURCE_INFO: '스타일 원본 정보',
    ORDER_QUANTITY: '주문 수량 수정',
    PATTERN_INFO: '패턴 참조 정보',
    PRODUCTION_INFO: '완제품 공급업체',
    MANUAL_STYLE: '수동 스타일 컬러 및 사이즈',
    MANUAL_COMMERCE: '수동 스타일 판매가 및 수량',
    ORDER_INFO: '입고 요청일',
    DESIGN: '디자인',
    COLORWAY: 'ColorWay 배색',
    USP: 'USP·디자인 의도',
    FABRIC_BASE: '원단 정보',
    FABRIC_PROD: '원단 생산 항목',
    TRIM: '부자재 BOM',
    CONSUMPTION: '원단 요척',
    TRIM_CONSUMPTION: '부자재 요척',
    PRICE: '단가',
    COST: '원가 입력',
    TRIM_TECHNICAL: '부자재 기술자료',
    SIZE_DEVIATION: '치수 편차',
    SIZE_SPEC: '기준치수',
    QUANTITY: '발주 수량(읽기 전용)',
    ONLINE: '온라인 상품 정보',
    QC: 'QC 의뢰서',
    TECHPACK_EXPORT: 'Tech Pack 최종 확인',
  },

  editScopeWhere: {
    MANUAL_STYLE: '상품기획에서 수동 스타일의 컬러 및 사이즈를 관리하고 디자이너가 샘플 사이즈를 선택합니다.',
    MANUAL_COMMERCE: '상품기획이 수동 스타일 판매가, 수량, 주문 정보 및 담당자를 관리합니다.',
    ORDER_INFO: '04절: 상품기획 또는 생산관리에서 입고 요청일을 수정합니다.',
    ORDER_QUANTITY: '상품기획에서 의뢰서의 색상별·사이즈별 주문 수량을 수정하며 원본과 수정 이력을 유지합니다.',
    PATTERN_INFO: '해당 스타일의 패턴사가 패턴 모듈 및 참조 의뢰서·스타일 번호를 관리합니다.',
    DESIGN: '01절: 도식화 / 메인정보 / 디자인 메모 / 상세 이미지',
    COLORWAY: '02절: ColorWay 배색표',
    USP: '08절: 핵심 셀링포인트와 디자인 의도',
    FABRIC_BASE: '02절 주자재: 사용부위 / 분류 / 코드 / 명칭 / 혼용률 / 후가공 / 공급처 / 적용 컬러',
    FABRIC_PROD: '02절 주자재: 원단 폭, 단위, 중량(메인 프로세스 7단계)',
    TRIM: '02절: 부자재 BOM의 구조와 속성',
    CONSUMPTION: '원단 요척은 패턴사가 입력',
    TRIM_CONSUMPTION: '부자재 요척은 디자이너가 입력하고 패턴사가 확인',
    PRICE: '02절: 주자재·부자재의 단가와 통화(원가 계산용)',
    COST: '02절 원가: 구매 방식, FOB 단가, 가공비, 외주 공정비, 통관비; 원가 스냅샷 확정',
    TRIM_TECHNICAL: '02절: 부자재 색상, 규격과 기술메모(패턴사)',
    SIZE_DEVIATION: '03절: 좌우 편차와 허용치(패턴사)',
    SIZE_SPEC: '03절: 기준치수, 사이즈별 값과 측정방법(패턴사)',
    QUANTITY: '04절: 이전 단계에서 확정된 발주 수량을 조회합니다.',
    ONLINE: '07절: 온라인 상품 정보',
    QC: '06절: QC 의뢰서 각 차수',
    TECHPACK_EXPORT: '05절: 생산 관리 최종 확인, 스타일 조회자는 내보내기 가능',
  },

  admin: {
    usersDesc:
      '한 사람당 하나의 역할입니다. 역할에 따라 의뢰서의 어느 모듈을 편집할 수 있는지 결정되며, 나머지는 조회만 가능합니다.',
    createUser: '사용자 등록',
    editUser: '사용자 수정',
    username: '계정 / 사번',
    usernameRequired: '계정을 입력하세요',
    usernamePattern: '계정은 영문, 숫자와 . _ - 만 사용할 수 있습니다',
    displayName: '이름',
    displayNameRequired: '이름을 입력하세요',
    role: '역할',
    roleRequired: '역할을 선택하세요',
    noRole: '미지정',
    department: '부서',
    email: '이메일',
    locale: '화면 언어',
    status: '상태',
    active: '사용',
    inactive: '중지',
    activate: '사용',
    deactivate: '중지',
    lastLogin: '최근 로그인',
    authProvider: '인증 방식',
    authLocal: '계정/비밀번호',
    authSso: '위챗워크',
    bound: '연동됨',
    searchPlaceholder: '계정 / 이름 / 이메일 검색',
    resetPassword: '비밀번호 재설정',
    resetPasswordConfirm:
      '{name} 의 비밀번호를 재설정할까요? 임시 비밀번호가 새로 발급되며 현재 로그인은 즉시 만료됩니다.',
    deactivateConfirm: '{name} 을(를) 중지할까요? 중지하면 즉시 로그인할 수 없습니다.',
    activateConfirm: '{name} 을(를) 다시 사용 상태로 바꿀까요?',
    cannotChangeOwnRole: '본인의 역할은 변경할 수 없습니다(스스로 잠기는 것을 방지)',
    brands: '조회 브랜드',
    allBrands: '전체 브랜드',
    noBrand: '미설정',
    brandsPlaceholder: '브랜드 선택(복수 선택 가능)',
    brandsHint: '업무 브랜드 권한을 개별 선택합니다. 미사용 브랜드의 기존 권한은 보관되지만 자료는 숨깁니다. 변경은 이후 접근 시 적용됩니다.',
    adminAllBrands: '관리자는 사용 중인 모든 브랜드의 업무를 조회하고 등록된 전체 브랜드를 관리합니다.',
    noBrandConfirm: '선택한 브랜드가 없어 이 사용자는 로그인해도 의뢰서를 하나도 볼 수 없습니다. 이대로 저장할까요?',
    tempPasswordHint: '등록하면 임시 비밀번호가 생성됩니다. 한 번만 표시되므로 복사해 본인에게 전달하세요.',
    tempPasswordTitle: '임시 비밀번호',
    tempPasswordWarn: '창을 닫으면 다시 볼 수 없습니다. 잊었다면 다시 재설정하세요.',
    copy: '복사',
    copied: '복사했습니다',
    copyFailed: '복사에 실패했습니다. 직접 선택해 주세요',
  },

  status: {
    DRAFT: '임시저장',
    PENDING: '승인 대기',
    APPROVED: '승인 완료',
    REJECTED: '반려',
    CANCELLED: '폐기',
  },

  server: {
    sapTransferInProgress: '이 스타일의 전송이 아직 끝나지 않았습니다. 처리 결과를 확인한 후 재전송 여부를 결정하세요.',
    sapMaintenance: '인터페이스 점검 중이므로 새 전송을 시작하지 않았습니다. 잠시 후 다시 시도하세요.',
    sapProbeReadOnly: '연결 확인은 스타일 조회에만 사용됩니다. 의뢰서 전송은 해당 스타일에서 실행하세요.',
    qcRemoveAttachmentsFirst: '이번 회차의 첨부파일을 먼저 제거한 후 QC 회차를 삭제해 주세요.',
    qcRoundMissing: 'QC 회차가 더 이상 존재하지 않습니다. 의뢰서를 다시 열어 주세요.',
    qcRoundCompleted: '이번 QC 회차는 완료되었습니다. 완료를 취소한 후 수정해 주세요.',
    rowEditConflict: '이 표가 변경되었습니다. 입력 내용은 보관되어 있습니다. 의뢰서를 다시 열어 확인한 후 저장해 주세요.',
    rowUndoUnavailable: '이 삭제는 되돌릴 수 없습니다.',
    rowUndoExpired: '되돌리기 시간이 지났습니다. 다시 입력해 주세요.',

    scopeReadonly: '현재 계정은 이 부분을 조회할 수 있습니다. 해당 스타일 담당자가 수정하세요.',
    materialRowsChanged: '원단 행이 변경되었습니다. 새로고침 후 확인하여 저장하세요.',
    sizeRowsChanged: '치수 행이 변경되었습니다. 새로고침 후 확인하여 저장하세요.',
    stageDesignMissing: '디자인 도안 또는 샘플 사이즈가 입력되지 않았습니다.',
    stageDeviationMissing: '기준 치수가 누락되었거나 QC 허용값이 유효한 숫자가 아닙니다. QC 허용값은 비워도 됩니다.',
    sizeGradingRange: '그레이딩 계산 결과는 음수이거나 99999999.99를 초과할 수 없습니다. 기준 치수와 좌우 그레이딩 값을 확인하세요.',
    sizeNumberInvalid: '치수와 그레이딩 값은 소수 둘째 자리까지, 절대값 99999999.99 이하로 입력하세요.',
    stageWidthMissing: '일부 원단에 유효한 폭이 없습니다.',
    stageTrimMissing: '일부 부자재의 코드 또는 적용 사이즈 규격이 없습니다.',
    stageUsageMissing: '일부 원단 또는 적용 부자재의 요척이 없습니다. 사용량이 없는 것이 확실하면 0을 입력할 수 있습니다.',
    patternSizeEmpty: '패턴 치수가 비어 있거나 측정부위 또는 치수 값이 누락되었습니다.',
    subMaterialRowsChanged: '부자재 행이 변경되었습니다. 새로고침하여 확인한 후 다시 저장하세요.',
    techpackNotReady: 'Tech Pack 자료 확인이 미완료입니다. 아래 작업을 먼저 완료하세요.',
    demoNoTransfer: '시연 자료는 업무 테스트용이며 SAP로 전송할 수 없습니다.',
    stageMismatch: '현재 섹션에 해당하는 확인 항목이 아닙니다. 페이지를 새로고침한 후 다시 시도하세요.',
    sapPreparationIncomplete: '디자이너와 패턴 담당자의 자료 확인을 먼저 완료하세요. 생산 담당자의 공장 전달 확인은 SAP 전송의 선행 조건이 아닙니다.',
    packNotConfirmed: '생산관리 담당자가 Tech Pack을 최종 확인해야 합니다.',
    testViewNoPassword: '테스트 사용자 관점에서는 계정 비밀번호를 변경할 수 없습니다.',
    assigneeOnlyDraft: '초안 또는 반려된 의뢰서에서 담당자를 변경할 수 있습니다.',
    assigneeMismatch: '해당 브랜드를 조회할 수 있고 역할이 일치하는 활성 계정을 선택하세요.',
    testViewClosed: '테스트 사용자 전환이 종료되었습니다. 관리자로 돌아가세요.',
    testViewBusinessOnly: '활성화된 업무 계정을 선택하세요.',
    roleNotFound: '역할이 존재하지 않습니다.',
    adminRoleProtected: '관리자 권한은 시스템에서 관리하며 여기서 변경할 수 없습니다.',
    unknownPermissions: '유효하지 않은 권한이 포함되어 있습니다. 새로고침 후 다시 시도하세요.',
    notSubmittable: '현재 상태에서는 승인 요청할 수 없습니다(초안 또는 반려 상태만 가능)',
    nothingToWithdraw: '승인 대기 중인 요청이 없어 철회할 수 없습니다',
    nothingToDecide: '결정 대기 중인 디자인 내용이 없습니다',
    rejectMemoRequired: '반려 시 의견은 필수입니다',
    badCredentials: '계정 또는 비밀번호가 올바르지 않습니다',
    accountDisabled: '정지된 계정입니다. 관리자에게 문의하세요',
    esiSessionExpired: 'AI Lab 로그인 세션이 만료되었습니다. 다시 로그인해 주세요',
    esiAccountNotConfigured: 'Design Sheet 이용 권한이 없습니다. 관리자에게 문의하세요',
    esiPasswordManaged: 'AI Lab 로그인 계정은 로컬 비밀번호를 설정하지 않습니다',
    sapResultNeedsCheck: '이전 전송 결과가 확인되지 않았습니다. SAP 기록을 확인한 후 진행해 주세요',
    userNotFound: '사용자가 존재하지 않습니다',
    wrongPassword: '현재 비밀번호가 올바르지 않습니다',
  },
  submitCheck: {
    noFlatSketch: '「디자인」 섹션에 도면이 없습니다',
    noStdSize: '「디자인」 섹션에 샘플 사이즈가 없습니다',
    noColorway: '「원부자재」 섹션의 ColorWay에 사용 중인 컬러가 1개 이상 필요합니다',
    stageNotDone: '「{section}」 섹션의 「{stage}」 완료 표시가 되어 있지 않습니다',
  },
  hero: {
    createTitle: '의뢰서 생성',
    createDesc: '오더페어 결과 또는 추가주문 결과로 새 스타일을 시작하세요. 기존 스타일 검색도 가능합니다.',
    fromOrderFair: '오더페어에서 생성',
    fromReorder: '추가주문에서 생성',
    reorderHint: '추가주문 인터페이스 연결 후 오픈 예정(준비 중)',
    moreWays: '다른 방법',
  },
  pipe: {
    toCreateHint: '최신 오더페어에서 아직 의뢰서를 만들지 않은 스타일입니다. 오더페어 목록에서 선택해 시작하세요.',
    title: '내 스타일 파이프라인',
    desc: '생성부터 공장 발송까지, 한 스타일이 지나가는 5단계입니다. 숫자를 누르면 해당 목록으로 이동합니다.',
    pendingApproval: '승인 대기(제출됨)',
    approved: '승인 완료',
    techpackSent: 'Tech Pack 확인 완료',
  },
  audit: {
    title: '감사 로그',
    desc: '시스템의 모든 쓰기 작업 기록 — 누가, 언제, 무엇을. 행을 클릭하면 변경 전후를 비교합니다.',
    keywordPh: '작업 / 대상 id 검색',
    targetType: '대상 유형',
    action: '작업',
    actor: '작업자',
    from: '시작 시각',
    to: '종료 시각',
    time: '시각',
    what: '작업 내용',
    target: '대상',
    detail: '상세',
    before: '변경 전',
    after: '변경 후',
    scopes: {
      sheet: '문서 전체', material: '원부자재', design: '디자인', pattern: '패턴·치수',
      qc: 'QC', usp: 'USP', online: '온라인 상품', cost: '원가', techpack: 'TechPack',
    },
  },
  sap: {
    transfer: 'SAP 전송',
    transferConfirm: '의뢰서 {modelCd}를 SAP(CE2)에 전송해 D-BOM을 생성할까요? 전송 내용과 로그가 보관됩니다.',
    transferTitle: 'SAP로 전송',
    transferOk: 'SAP 전송 완료(「SAP 전송 상태」 페이지 참조)',
  },
  switch: {
    account: '테스트 계정 전환(브랜드×역할)',
    roleOnly: '역할만 전환',
    reset: '본인으로 복원',
  },
  about: {
    title: 'Design Sheet 정보',
    desc: '소프트웨어 버전 정보와 릴리스 번호 규칙입니다.',
    version: '소프트웨어 버전',
    stage: '릴리스 단계',
    devStage: '개발 중',
    testStage: '테스트 버전',
    buildTime: '빌드 시각',
    noteSeparate: '소프트웨어 버전은 앱 릴리스를 식별합니다. 의뢰서 단계는 평가회·수주회·본 생산을 기록하며 숫자 기록 버전 및 QC 차수와 별도로 관리합니다.',
    versionLine: '문의 시 아래 버전 정보를 첨부해 주세요:',
    rulesTitle: '버전 번호 규칙',
    colNo: '번호',
    colWhen: '적용 시점',
    rulePatch: '문제 수정·패치 번호 증가',
    ruleMinor: '호환 기능 추가·마이너 번호 증가',
    ruleMajor: '정식 릴리스 버전',
    ruleRc: '정식 릴리스 전 후보 버전',
    rulesNote: '버전 번호의 유일한 출처는 프로젝트 루트 package.json이며 빌드 흐름에서 주입됩니다. 이 페이지는 읽기 전용입니다.',
  },
  board: {
    taskArea: '업무 목록',
    taskScope: '업무 범위',
    scopes: { pending: '처리할 업무', mine: '내 담당 업무', brand: '브랜드 전체' },
    scopeHints: { pending: '현재 직무에서 내가 처리해야 할 업무를 확인합니다.', mine: '진행 중, 완료 및 폐기된 의뢰서를 포함하여 내 담당 업무를 확인합니다.', brand: '접근 권한이 있는 브랜드의 모든 의뢰서를 확인합니다.' },
    quickFilters: '빠른 필터',
    shortcutHint: '숫자는 해당하는 내 업무의 전체 건수입니다. 클릭하면 검색어와 심사 상태 조건을 지우고 해당 의뢰서를 표시합니다.',
    filteredBy: '적용된 필터',
    resetFilters: '필터 초기화',
    groupBy: '그룹',
    displayMode: '표시 방식',
    resultCount: '의뢰서 총 {count}건',
    loadingTasks: '업무를 불러오는 중…',
    noMatches: '조건에 맞는 업무가 없습니다',
    noMatchesHint: '검색 조건을 조정하거나 필터를 초기화해 주세요.',
    noPending: '현재 처리할 업무가 없습니다',
    noTasks: '현재 업무가 없습니다',
    emptyHints: { pending: '“내 담당 업무”에서 처리한 의뢰서와 다른 상태의 의뢰서를 확인할 수 있습니다.', mine: '현재 나에게 배정된 의뢰서가 없습니다.', brand: '접근 가능한 브랜드에 아직 의뢰서가 없습니다.' },
    showMine: '내 담당 업무 보기',
    pendingTasks: '처리할 업무',
    allTasks: '전체 업무',
    pageGroupCount: '현재 페이지{count}건',

    searchPh: '스타일 / 의뢰서 번호 / 품명 검색',
    title: '상품 보드',
    group: { none: '그룹 없음', progress: '완료도별', season: '연도·시즌별', source: '출처별' },
    viewCard: '카드',
    viewList: '목록',
    viewAll: '전체 보기',
    done: '완료',
    ongoing: '진행 중',
    cancelled: '폐기',
    unclassified: '미분류',
    continue: '계속 작성',
    view: '보기',
    emptyTitle: '아직 상품이 없습니다',
    noImage: '이미지 없음',
    field: { brand: '브랜드', season: '시즌', source: '출처' },
    progress: '진행률',
    empty: '의뢰서가 없습니다 — 「의뢰서 목록」에서 생성하세요',
  },
  source: {
    SAP_LEGACY: "SAP · 배정 스타일",
    DEMO: '데모 자료',
    ORDER_FAIR: '대량 · 오더페어',
    MANUAL: '수동 생성',
    REORDER: '추가주문 · 자사 분석 제안',
  },
  devSwitch: {
    label: '테스트 · 역할 전환',
    restore: '본인으로 복원',
  },
  error: {
    VALIDATION_FAILED: '입력 내용에 오류가 있습니다. 확인 후 다시 시도하세요',
    UNAUTHORIZED: '로그인이 만료되었습니다. 다시 로그인하세요',
    TOKEN_EXPIRED: '로그인이 만료되었습니다. 다시 로그인하세요',
    FORBIDDEN: '해당 작업을 수행할 권한이 없습니다',
    NOT_FOUND: '요청한 데이터가 존재하지 않습니다',
    CONFLICT: '데이터 충돌이 발생했습니다. 새로고침 후 다시 시도하세요',
    INVALID_STATE: '현재 문서 상태에서는 해당 작업을 수행할 수 없습니다',
    RATE_LIMITED: '요청이 너무 잦습니다. 잠시 후 다시 시도하세요',
    SAP_ERROR: 'SAP 인터페이스 오류입니다. 관리자에게 문의하세요',
    SERVICE_UNAVAILABLE: '서비스를 일시적으로 이용할 수 없습니다(데이터베이스 연결 오류). 잠시 후 다시 시도하세요',
    INTERNAL_ERROR: '서버 오류입니다. 잠시 후 다시 시도하세요',
    PAYLOAD_TOO_LARGE: '내용이 허용 크기를 초과했습니다. 압축하거나 나누어 다시 시도하세요',
    invalidJson: '요청 내용 형식이 올바르지 않습니다(유효한 JSON 아님). 새로고침 후 다시 시도하세요',
    payloadTooLarge: '제출한 내용이 상한{p0}을 초과했습니다. 압축하거나 나누어 다시 시도하세요',
    uploadFileTooLarge: '파일 한 개가 상한{p0}을 초과했습니다. 압축 후 다시 업로드하세요',
    uploadFileCount: '한 번에 최대 {p0}개까지 업로드할 수 있습니다. 나누어 업로드하세요',
    uploadUnexpectedField: '업로드 필드 「{p0}」은(는) 이 API에서 허용되지 않습니다',
    uploadFormLimit: '업로드 양식이 제한({p0})을 초과했습니다. 파일이나 필드를 줄여 다시 시도하세요',
    invalidRequestEncoding: '지원하지 않는 요청 형식입니다. 새로고침 후 다시 시도하세요',
    NETWORK: '네트워크 연결에 실패했습니다. 네트워크를 확인하세요',
    UNKNOWN: '알 수 없는 오류가 발생했습니다',
    requestId: '오류 추적번호',
  },

  page: {
    todo: {
      title: '내 할 일',
      desc: '현재 처리가 필요한 사항 요약입니다. 카드를 클릭하면 해당 문서로 이동합니다. 0은 대기 중인 항목이 없음을 의미합니다.',
      toCreate: '생성 대기(신규)',
      todoDrafting: '작성 중(초안)',
      pendingApproval:'승인 대기',
      rejected: '반려되어 수정 필요',
      missingPrice: '단가 미입력 행 있음',
      missingUsage: '소모량 미입력 행 있음',
      technicalPending: '기술 자료 완료 대기',
      approvedNotTransferred: 'SAP 동기화 대기',
      go: '보기',
    },
    dashboard: {
      title: '워크벤치',
      eyebrow: 'WORKBENCH',
      welcome: '{name}님, 환영합니다',
      scopeTitle: '이번 버전의 재구축 범위',
      scopeDesc: '이번 버전은 메인 프로세스 5~13단계를 다루며, 나머지 단계는 SAP에서 계속 운영됩니다.',
      inScope: '이번 범위',
      outOfScope: '해당 없음',
    },
    notFound: {
      title: '페이지를 찾을 수 없습니다',
      desc: '요청한 페이지가 존재하지 않거나 삭제되었습니다.',
      back: '워크벤치로 이동',
    },
    forbidden: {
      title: '접근 권한이 없습니다',
      desc: '이 페이지에 접근할 권한이 없습니다. 필요한 경우 시스템 관리자에게 문의하세요.',
      back: '워크벤치로 이동',
    },
  },

  integration: {
    pageHint: "EADS ↔ SAP PI 인터페이스 연결 상태. 테스트는 수동이며 실제로 SAP를 한 번 호출합니다. 인증 실패는 계정 보호에 누적됩니다.",

    tunnelTitle: 'SSH 점프 서버',
    tunnelHint: '방화벽 때문에 내부망 엔드포인트에 직접 연결할 수 없어 점프 서버를 경유합니다(ssh -L과 동일). 업무 로직은 그대로이며 경로만 달라집니다',
    tunnelConnected: '연결됨, 로컬 포워딩 포트 {port}',
    tunnelIdle: '미연결 — 다음 호출 시 자동으로 연결됩니다',
    tunnelNotConfigured: '설정 부족: 호스트·사용자와 비밀번호(또는 개인키)가 필요합니다',
    tunnelNoFingerprint: '호스트 지문이 설정되지 않아 SSH 호스트 검증을 건너뜁니다 — 중간자 공격을 탐지할 수 없습니다. ssh-keyscan으로 지문을 확인해 .env에 넣으세요',
    tunnelReconnect: '점프 서버 재연결',
    tunnelReconnected: '연결을 끊었습니다. 다음 호출 시 다시 연결됩니다',
    step: {
      'jump-tcp': '① 본 PC → 점프 서버',
      'ssh-auth': '② SSH 로그인',
      forward: '③ 점프 서버 → 내부망 엔드포인트',
      http: '④ 엔드포인트 HTTP 응답 여부',
      config: '설정 확인',
    },
    reachTitle: "네트워크 연결",
    reachHint: "TCP 핸드셰이크만 수행하며 계정 정보를 보내지 않습니다. 문제 확인은 여기부터 —— 네트워크가 안 되면 비밀번호가 맞아도 인증 자체가 일어나지 않으므로 잠금 횟수에도 포함되지 않습니다.",
    reachRun: "연결 확인",
    enabled: "전체 스위치",
    on: "켜짐",
    off: "꺼짐",
    credentials: "인터페이스 계정",
    configured: "설정됨",
    missing: "미설정",
    sysGbn: "시스템 구분",
    endpoint: "엔드포인트",
    circuitClosed: "계정 보호 정상",
    circuitOpen: "계정 보호 차단됨",
    circuitUncertain: "인증 결과 확인이 필요하여 전송을 중지했습니다. 최초 활성화 또는 이전 요청의 응답이 불명확한 경우, 기존 프로세스와 계정 상태를 확인한 후 관리자가 초기화하세요. 불명확한 결과는 확정된 인증 실패 횟수에 포함되지 않습니다.",
    circuitDesc: "인증 연속 실패 {failures} / {limit}회, 로컬에서 {remaining}회 남았습니다. SAP 측은 연속 3회면 계정이 잠깁니다.",
    reset: "복구",
    resetConfirmTitle: "계정 보호 복구",
    resetConfirm: "복구 전에 인터페이스 계정 비밀번호가 정확한지 확인하세요. 비밀번호가 틀린 상태로 계속 호출하면 SAP 측 실패 횟수가 3회에 도달해 계정이 잠깁니다. 계속할까요?",
    resetConfirmOk: "확인했습니다, 복구",
    resetDone: "복구되었습니다",
    id: "인터페이스 번호",
    interfaceName: "Interface 명",
    description: "설명",
    usedBy: "사용처",
    lastProbe: "최근 테스트",
    notProbed: "미테스트",
    probe: "연결 테스트",
    probeStyleCd: "테스트용 스타일번호",
    probeStyleCdPlaceholder: "비우면 기본값 사용",
    probeStyleCdHint: '카탈로그에서 「연결 테스트」 시 사용할 스타일 코드. 비우면 서버 기본값을 사용합니다',

    catalogTitle: '인터페이스 카탈로그',
    catalogHint: '백엔드 팀 인터페이스 목록의 전체 버전으로, 문서처럼 조회할 수 있습니다. 검색은 필드명까지 포함합니다',
    catalogCounts: '전체 {total}개 · 당사 호출 가능 {callable}개 · 구현 완료 {implemented}개 · 현재 표시 {shown}개',
    catalogSearchPh: '인터페이스 번호 / 이름 / 설명 / 필드명 검색',
    catalogNoMatch: '일치하는 인터페이스가 없습니다',
    dirAll: '전체',
    dirOut: 'EADS → SAP',
    dirIn: 'SAP → EADS',
    dirOutShort: '당사 호출',
    dirInShort: 'SAP 전송',
    onlyInUse: '사용 중만',
    onlyImplemented: '구현 완료만',
    noSummary: '(인터페이스 목록에 설명이 없습니다)',
    noFields: '인터페이스 정의서에 이 인터페이스의 필드표가 없습니다',
    tagAsync: '비동기',
    tagUnused: '미사용',
    stage: {
      done: '구현 완료',
      registered: '등록됨',
      none: '미연동',
    },
    metaProgram: 'SAP 프로그램',
    metaTransport: '전송 방식',
    metaCycle: '호출 주기',
    metaNs: '네임스페이스',
    metaAdapter: '어댑터',
    metaOwner: '백엔드 담당',
    metaNote: '비고',
    fField: '필드',
    fDesc: '설명',
    fType: '타입',
    fLen: '길이',
    fSample: '예시',
    fTable: '내부 테이블',
    probeConfirmTitle: "인터페이스 연결 테스트",
    probeConfirm: "{id}을(를) 실제로 한 번 호출합니다. 인증 실패 시 계정 보호에 누적되며 로컬에서 {n}회 남습니다. SAP 측은 연속 3회면 계정이 잠깁니다. 진행할까요?",
    probeConfirmOk: "진행"
  },
  sapSpot: {
    wired: '연동됨',
    notWired: '미연동',
  },

  integrationResult: {
    "OK": "연결됨",
    "BUSINESS_ERROR": "업무 오류",
    "AUTH_FAILED": "인증 실패",
    "UNREACHABLE": "네트워크 불가",
    "BAD_RESPONSE": "응답 이상",
    "NOT_CONFIGURED": "미설정",
    "CIRCUIT_OPEN": "보호 차단",
    "BUSY": "인터페이스 호출 중",
    "SAFETY_UNAVAILABLE": "인터페이스 보호 일시 사용 불가",
    "UNKNOWN": "알 수 없음"
  },
  legacy: {
    eyebrow: '구시스템 EADS',
    listTitle: '과거 의뢰서',
    listDesc: '구시스템에서 이전된 과거 데이터(2019년~), 읽기 전용',
    detailDesc: '구시스템 과거 데이터, 읽기 전용',
    keywordPlaceholder: '품번 / 스타일번호 / 스타일명',
    brand: '브랜드',
    year: '년도',
    state: '상태',
    stateCol: '상태',
    modelCd: '의뢰서 품번',
    styleCd: '스타일번호',
    styleNm: '스타일명',
    yearSeason: '년도 / 시즌',
    designer: '디자이너',
    colors: '컬러',
    trims: '부자재',
    createdAt: '등록일',
    empty: '데이터 없음',
    colorways: '컬러웨이',
    tagColor: '택 컬러',
    washing: '세탁 정보',
    materials: '원단',
    usedPart: '사용부위',
    materialId: '원단 번호',
    materialNm: '원단명',
    yardage: '소요량',
    width: '유폭',
    unit: '단위',
    unitPrice: '단가',
    ingredient: '혼용률',
    trimsSection: '부자재 BOM',
    trimCode: '부자재 코드',
    trimName: '부자재명',
    trimType: '종류',
    colorMatchPart: '배색부위',
    consumption: '소요량 상세',
    memo: '메모',
    stdSizes: '샘플 사이즈',
    patternPart: '부위',
    size: '사이즈',
    tolerance: '공차',
    measurement: '측정 방법',
    progress: '진행 이력',
    statusDate: '일자',
    comment: '내용',
    modiHistory: '수정 이력',
    modiTime: '일시',
    amendTable: '테이블',
    amendField: '필드',
    beforeAfter: '변경 전 → 후',
    designMemos: '디자인 메모',
    salePrice: '판매가',
    chargePattern: '패턴 담당',
    chargePurchase: '구매 담당',
    chargeProduction: '생산 담당',
  },

  dict: {
    eyebrow: '기준정보',
    title: '기준 사전',
    desc: '상품 컬러(브랜드별), 사이즈-분류 매핑, 원자재 컬러. 참조 파일에서 최초 가져온 뒤 화면에서 관리',
    colorTitle: '컬러 사전',
    colorDesc: '상품 컬러는 브랜드별로, 소재 컬러는 SAP 원자재 컬러로 관리합니다. 두 사전이 선택 목록과 검색의 기준입니다.',
    sizeTitle: '사이즈 사전',
    sizeDesc: '브랜드마다 하나의 사이즈 세트를 두고 「사이즈 체계」별로 묶어 관리합니다. 같은 체계 안에서 같은 코드는 한 번만 저장됩니다.',
    sizeSummary: '{segments}개 체계 · {sizes}개 사이즈',
    sizeAdd: '사이즈 추가',
    sizeAddPlaceholder: '사이즈 입력',
    sizeAdded: '사이즈 {size} 추가됨',
    sizeDeleteConfirm: '사이즈 {size}을(를) 삭제할까요? 기존 전표는 영향 없지만 신규 작성 시 선택할 수 없습니다.',
    brandColor: '상품 컬러',
    sizeCategory: '사이즈 분류',
    materialColor: '원자재 컬러',
    keywordPlaceholder: '코드 / 명칭 검색',
    brand: '브랜드',
    colorCd: '컬러 코드',
    colorNm: '영문명',
    nameZh: '중문명',
    nameKo: '한국어명',
    used: '사용',
    cate1: '대분류 코드',
    cate1Name: '대분류 명칭',
    cate1NameZh: '대분류 중문명',
    cate1NameKo: '대분류 한국어명',
    cate1Placeholder: '대분류 없으면 비움',
    sizeCd: '사이즈 코드',
    segment: '사이즈 구분',
    segmentZh: '사이즈 구분(중문)',
    segmentKo: '사이즈 구분(한국어)',
    brands: '적용 브랜드',
    family: '컬러 계열',
    colorName: '컬러명',
    approxColor: '근사 팬톤 컬러',
    hexCode: '근사 색상값',
    approxPantoneCode: '근사 팬톤 코드',
    pantoneCd: '팬톤 번호',
    approxHint: '색상 칩은 컬러 계열과 컬러명으로 추정한 값이며 화면 표시용입니다. 정확한 대조는 실제 색상 카드나 공식 팬톤 값으로 확인해 주세요.',
    notCollected: '미수집',
    add: '추가',
    addTitle: '사전 항목 추가',
    editTitle: '사전 항목 편집',
    deleteConfirm: '이 사전 항목을 삭제하시겠습니까? 이미 입력된 의뢰서의 기존 값은 유지되며, 목록에서만 사라집니다.',
  },
  sapTransfer: {
    duration: '소요 시간',
    inProgress: '진행 중',
    states: { SUCCESS: '전송 완료', FAILED: '전송 실패', SENDING: '전송 중', PENDING: '전송 대기', RECONCILE: '결과 확인 필요' },
    empty: '전송 기록이 없습니다 —— 승인된 의뢰서를 SAP로 전송하면 여기에 표시됩니다.',
    title: 'SAP 전송 이력',
    desc: '의뢰서를 SAP(SP0070)에 전송한 기록입니다. 실패한 건은 수동 재전송할 수 있습니다',
    refresh: '새로고침',
    allStatus: '전체 상태',
    time: '시작 시각',
    sheet: '의뢰서',
    channel: '채널',
    status: '상태',
    error: '실패 사유',
    by: '작업자',
    actions: '작업',
    resend: '재전송',
    resendTitle: 'SAP 전송 재시도',
    resendConfirm: '의뢰서 {model}을(를) 다시 전송할까요? 최신 내용으로 사전 검사부터 전체를 다시 진행합니다.',
    resendOk: '재전송 성공',
  },

};
